import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs";
import { resolve } from "path";
import { CircularInjectionHelper } from "../services/circularInjectionHelper";
import { SnackBarService, snackBarMessageKey } from "../services/snackBar.service";
import { SnackBarMessageType } from "../shared/contentTypes";
import { StorageHive, LocalKeys } from "../services/valueStorage.service";
import { UserHelperService } from "../services/userHelper.service";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class WebvoucherGuard implements CanActivate {
  constructor(private _circularInjectionHelper: CircularInjectionHelper
    , private _router: Router
    , private _snackBarService: SnackBarService
    , private _userHelperService: UserHelperService) {

  }
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const me = this;
    return new Promise<boolean>((resolve, reject) => {
      me._userHelperService.HasWebVoucher()
        .then((response) => {
          if (response) {
            resolve(true);
          } else {
            me._router.navigateByUrl("/webvoucher");
            resolve(false);
          }
        })
        .catch(e => {
          me._circularInjectionHelper.coreLogService.error("WebvoucherGuard.canActivate", "_userHelperService.hasWebVoucher", e);
          me._snackBarService.ShowErrorMessageFailed(110);
          resolve(false);
        });
    });
  }
}
